<template>
    <div class="mosaic">
        <v-container>
            <v-row>
                <v-col cols="6" md="4" v-for="(tile,t) in tiles" :key="'tile-col-'+t">
                    <template v-if="tile.link[0] == '/'">
                        <router-link :to="tile.link">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+tile.image.path"></v-img>
                        </router-link>
                    </template>
                    <template v-else>
                        <a :href="tile.link" target="_blank">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+tile.image.path"></v-img>
                        </a>
                    </template>
                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
export default {
    data(){
        return {
            tiles: []
        }
    },
    beforeMount: function(){
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Mosaic?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    
                },
                populate: 1 // resolve linked collection items
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.tiles = res.entries))   
    }
}
</script>